import HoneybadgerVue from '@honeybadger-io/vue'
import Vue from 'vue'
import { getEnvironment } from '@/utils/env-helper'

const env = getEnvironment()
const trackingEnabled = ['Beta', 'Live'].includes(getEnvironment())

if (trackingEnabled) {
  Vue.use(HoneybadgerVue, {
    apiKey: 'hbp_4HpwAPS7nq8XsfayCix0pNFMRyGDoZ2Y9YL3',
    environment: env,
    disabled: env === 'Development',
    onerror: env !== 'Development',
    debug: env !== 'Live',
  })
}
